import React, { useEffect } from 'react';

// components
import InstallHintBanner from 'pwa/components/InstallHintBanner';

// hooks
import useIosInstallHint from 'pwa/hooks/useIosInstallHint';
import { usePosthogCapture } from 'pwa/posthogCapture/_index';

export default function IosInstallHint(): JSX.Element | null {
  const { isVisible, dismiss } = useIosInstallHint();
  const capture = usePosthogCapture();

  useEffect(() => {
    if (!isVisible) return;
    capture.installHintShown();
  }, [isVisible, capture]);

  if (!isVisible) return null;

  const handleDismiss = (): void => {
    capture.installHintDismissed();
    dismiss();
  };

  return <InstallHintBanner onDismiss={handleDismiss} />;
}
